import { ActivitiesOrderModel } from "./ActivitiesOrder.model";

export class ActivitiesOrder extends ActivitiesOrderModel {
    // Add custom methods here
}
